<div class="modal-content">
    <form #memberForm="ngForm" class="pt-3">
	    <div class="bg-default rounded-lg p-4 border border-gray-200 grid grid-cols-1 md:grid-cols-3 gap-y-2 gap-x-4 items-center">
            <mat-radio-group [(ngModel)]="currentMember.flagType" [name]="'flagType-' + type" color="primary" class="flex-shrink-0" 
                aria-label="Select an option" (change)="onFlagTypeChange($event)">
                <mat-radio-button [value]="0">Grupo</mat-radio-button>
                <mat-radio-button [value]="1">Miembro</mat-radio-button>
            </mat-radio-group>
            @if(currentMember.flagType == 0){
            <mat-form-field appearance="fill" class="w-full" floatLabel="never">
                <mat-select [(ngModel)]="currentMember.currentGroup" name="currentGroup">
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchGroup" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="changueOptionsGroup($event)" placeholderLabel="Buscar grupo..."
                            noEntriesFoundLabel="No se encontraron resultados">
                        </ngx-mat-select-search>
                    </mat-option>
                    @for (group of groupsFilterList(); track group) {
                        <mat-option [value]="group" >
                            {{ group.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            }@else{
            <mat-form-field appearance="fill" class="w-full" floatLabel="never">
                <mat-select [(ngModel)]="currentMember.currentMember" name="currentMember">
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchMember" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="changueOptionsMember($event)" placeholderLabel="Buscar miembro..."
                            noEntriesFoundLabel="No se encontraron resultados">
                        </ngx-mat-select-search>
                    </mat-option>
                    @for (member of membersFilterList(); track member) {
                        <mat-option [value]="member" >
                            {{ member.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            }
            <div class="flex justify-end w-full">
                <button mat-icon-button color="primary" (click)="addMembers()" matTooltip="Nuevo Registro">
                    <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                </button>
            </div>
        </div>
    </form>
    <div class="relative flex flex-0 flex-col py-3 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
            <!-- Search -->
            <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
                <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                <input matInput placeholder="Buscar" autocomplete="off" (input)="applyFilter($event.target.value)" />
            </mat-form-field>
        </div>
    </div>
    <div class="container mt-0 flex-auto flex-col overflow-x-auto">
        <!-- Header -->
        <div class="sticky top-0 z-10 bg-gray-100 dark:bg-gray-900">
            <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSourceMembers"
                matSort matSortDisableClear multiTemplateDataRows>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Nombre</th>
                    <td mat-cell *matCellDef="let element" class="px-6 text-left text-uppercase">
                        {{ element?.name}}
                    </td>
                </ng-container>
                <!-- Company -->
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Correo</th>
                    <td mat-cell *matCellDef="let element" class="px-6 text-left text-lowercase">
                        {{ (element?.email || []).slice(0, 1).join(', ') }}
                        <ng-container *ngIf="(element?.email?.length || 0) > 1">
                            <span matTooltip="{{ (element?.email || []).slice(1).join(', ') }}">
                                , <b>+{{ (element?.email?.length || 0) - 1 }} más</b>
                            </span>
                        </ng-container>
                    </td>
                </ng-container>
                <ng-container matColumnDef="phone">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Telefono</th>
                    <td mat-cell *matCellDef="let element" class="px-6 text-left text-lowercase">
                        {{ (element?.phone || []).slice(0, 1).join(', ') }}
                        <ng-container *ngIf="(element?.phone?.length || 0) > 1">
                            <span matTooltip="{{ (element?.phone || []).slice(1).join(', ') }}">
                                , <b>+{{ (element?.phone?.length || 0) - 1 }} más</b>
                            </span>
                        </ng-container>
                    </td>
                </ng-container>
                <!-- Acciones -->
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left">
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index" class="px-6 py-3 text-left">
                        <button mat-menu-item color="primary" (click)="openDeleteDialog(element, i)"
                            matTooltip="Eliminar Registro">
                            <mat-icon svgIcon="heroicons_outline:trash" color="warn"></mat-icon>
                        </button>
                    </td>
                </ng-container>
                <!-- Header Row -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"
                    class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
                <!-- Fila principal -->
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
            </table>
        </div>
        <div *ngIf="this.dataSourceMembers.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo
            sentimos, no hay registros para mostrar.
        </div>
    </div>
</div>
<ng-template #deleteDialog let-data>
    <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
            <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
                style="font-size: 32px;"></mat-icon>
        </div>
        <div class="grid">
            <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
            <mat-dialog-content class="modal-content mt-0">
                <p>¿Está seguro que desea eliminar el registro?</p>
            </mat-dialog-content>
        </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Conservar</button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
    </mat-dialog-actions>
</ng-template>